import React, { useEffect, useState } from "react";
import { CalendarClock, MapPin, Tv } from "lucide-react";
import { api } from "../lib/api";

const GOLD = "#d8b854";
const dateLabel = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  const today = new Date(); today.setHours(12, 0, 0, 0);
  const diff = Math.round((d - today) / 86400000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
};

// Player Dashboard hero · next scheduled game (ESPN for NBA/D1, school site for D2/D3). Renders nothing when there is none.
export function NextGameCard({ playerId, league }) {
  const [g, setG] = useState(undefined);
  useEffect(() => {
    if (!["NBA", "WNBA", "NCAA", "WNCAA"].includes(league)) { setG(null); return; }
    api.nextGame(playerId).then(r => setG(r.game)).catch(() => setG(null));
  }, [playerId, league]);
  if (!g) return null;
  const vs = g.home_away === "home" ? "vs" : g.home_away === "away" ? "@" : "vs (N)";
  const label = dateLabel(g.date_local);
  return (
    <div className="bg-[#141414] border border-white/10 relative" style={{ animation: "homeIn .6s ease both", animationDelay: "80ms" }} data-testid="home-next-game">
      <div className="flex items-center border-b border-white/10">
        <div className="px-4 py-2.5 text-[10px] uppercase tracking-[0.3em] font-bold text-[#121212]" style={{ background: GOLD }}>Next Game</div>
        <div className={`px-4 text-[10px] uppercase tracking-[0.25em] flex items-center gap-1.5 ${label === "Today" ? "text-[#d8b854]" : "text-[#757575]"}`} data-testid="home-next-game-date"><CalendarClock className="w-3 h-3" /> {label}</div>
      </div>
      <div className="p-5 flex items-center justify-between gap-4">
        <div className="min-w-0 flex items-center gap-3">
          {g.opponent_logo && <img src={g.opponent_logo} alt="" className="w-10 h-10 object-contain shrink-0" onError={(e) => { e.currentTarget.style.display = "none"; }} />}
          <div className="min-w-0">
            <div className="text-[9px] uppercase tracking-[0.3em] text-[#757575]">{g.home_away === "home" ? "Home" : g.home_away === "away" ? "Away" : "Neutral"}</div>
            <div className="font-heading text-2xl text-white uppercase truncate" data-testid="home-next-game-opponent"><span className="text-[#575757] mr-2">{vs}</span>{g.opponent || "TBA"}</div>
            {g.venue && <div className="text-[11px] text-[#757575] truncate flex items-center gap-1"><MapPin className="w-3 h-3 shrink-0" />{g.venue}</div>}
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-heading text-3xl leading-none text-white" data-testid="home-next-game-tip">{g.tip_et}</div>
          <div className="text-[9px] uppercase tracking-[0.2em] text-[#757575] mt-1 flex items-center gap-1 justify-end">{g.broadcast ? <><Tv className="w-3 h-3" />{g.broadcast}</> : g.tip_et === "TBD" ? "Time TBA" : "ET"}</div>
        </div>
      </div>
    </div>
  );
}
